import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';

import { IOperacion, ITopMenu, EVistas } from './adminmenu/adminMenu.component';
import { Usuario } from '../../common/usuario';
import { UsuarioService } from '../_services/usuario.service';

import { CallcenterComponent } from './consola_call/callcenter.component';

@Component({
    selector: 'admin-comp', 
    styles: [require('./admin.component.css')],
    template: require('./admin.component.html')
})
export class AdminComponent implements OnInit {
    
    @ViewChild(CallcenterComponent)
    callcenter: CallcenterComponent;
    
    private nombre: string          // Nombre de la cola
    
    private vm = EVistas;           // variable usuada en el switch
    private usuario: Usuario;
    private _menu: ITopMenu = {};
    
    constructor (private $route: ActivatedRoute, private $usuario: UsuarioService) { 
        this.usuario = <Usuario>this.$route.snapshot.data['usuario'];
        console.log('Bienvenido ' + this.usuario.usuario);
        this.$usuario.usuario = this.usuario;
    }
    
    ngOnInit () { 
        this.ejecutarOperacion({ vista: EVistas.EXTENSIONES, subVista: '' });
    }
    
    /**
     * Función que cambia la vista o lanza nuevos componentes
     * @param op: IOperacion
     */
    //<editor-fold defaultstate="collapsed" desc="ejecutarOperacion(op: IOperacion)">
    ejecutarOperacion(op: IOperacion) {
        
        // Si es callcenter, obtener los colas disponibles
        if (op.vista === EVistas.CALLCENTER && !!op.subVista) {
            if (op.subVista === "NUEVA")
                this.callcenter.crearQueue();            
            else
                this._menu.nombre = op.subVista;
        }
        else {
            // cambiar la vista
            this._menu = {
                current_view: op.vista,
                nombre: op.subVista
            };
        }
    }
    //</editor-fold>
    
    addMenuOptions (opciones: string[]) {
        this._menu.menu = opciones;
    }
    
    addStats (stats: {nombre: string, valor: string}[]) {
        this._menu.stats = stats;
    }
    
    changeMenuNombre (nombre: string) {
        this._menu.nombre = nombre;
    }
} 



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/admin.component.ts